module.exports = __webpack_public_path__ + "static/media/github.44e78c14.svg";